/**
 * Sync user-visible API client messages by current UI language (localStorage besper-language).
 * Used where apiClient returns { error } before any React i18n context exists.
 */

const M = {
  en: {
    authNotConfigured: 'Authentication not configured (missing ENTRA_API_SCOPE)',
    authRequired: 'Authentication required'
  },
  de: {
    authNotConfigured: 'Authentifizierung nicht konfiguriert (ENTRA_API_SCOPE fehlt)',
    authRequired: 'Anmeldung erforderlich'
  },
  es: {
    authNotConfigured: 'Autenticación no configurada (falta ENTRA_API_SCOPE)',
    authRequired: 'Se requiere autenticación'
  },
  fr: {
    authNotConfigured: 'Authentification non configurée (ENTRA_API_SCOPE manquant)',
    authRequired: 'Authentification requise'
  },
  it: {
    authNotConfigured: 'Autenticazione non configurata (manca ENTRA_API_SCOPE)',
    authRequired: 'Autenticazione richiesta'
  },
  pt: {
    authNotConfigured: 'Autenticação não configurada (falta ENTRA_API_SCOPE)',
    authRequired: 'Autenticação necessária'
  },
  nl: {
    authNotConfigured: 'Authenticatie niet geconfigureerd (ENTRA_API_SCOPE ontbreekt)',
    authRequired: 'Authenticatie vereist'
  },
  pl: {
    authNotConfigured: 'Uwierzytelnianie nie jest skonfigurowane (brak ENTRA_API_SCOPE)',
    authRequired: 'Wymagane uwierzytelnienie'
  },
  sv: {
    authNotConfigured: 'Autentisering inte konfigurerad (ENTRA_API_SCOPE saknas)',
    authRequired: 'Autentisering krävs'
  },
  no: {
    authNotConfigured: 'Autentisering ikke konfigurert (mangler ENTRA_API_SCOPE)',
    authRequired: 'Autentisering kreves'
  },
  da: {
    authNotConfigured: 'Godkendelse ikke konfigureret (ENTRA_API_SCOPE mangler)',
    authRequired: 'Godkendelse påkrævet'
  },
  fi: {
    authNotConfigured: 'Todennusta ei ole määritetty (ENTRA_API_SCOPE puuttuu)',
    authRequired: 'Todennus vaaditaan'
  },
  cs: {
    authNotConfigured: 'Ověření není nakonfigurováno (chybí ENTRA_API_SCOPE)',
    authRequired: 'Vyžadováno přihlášení'
  },
  hu: {
    authNotConfigured: 'Hitelesítés nincs beállítva (hiányzik az ENTRA_API_SCOPE)',
    authRequired: 'Bejelentkezés szükséges'
  },
  ro: {
    authNotConfigured: 'Autentificare neconfigurată (lipsește ENTRA_API_SCOPE)',
    authRequired: 'Autentificare necesară'
  },
  el: {
    authNotConfigured: 'Η ταυτοποίηση δεν έχει ρυθμιστεί (λείπει ENTRA_API_SCOPE)',
    authRequired: 'Απαιτείται ταυτοποίηση'
  },
  id: {
    authNotConfigured: 'Autentikasi belum dikonfigurasi (ENTRA_API_SCOPE hilang)',
    authRequired: 'Autentikasi diperlukan'
  }
};

export function getApiUserMessage(key) {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return M.en[key] || key;
  }
  const lang = localStorage.getItem('besper-language') || 'en';
  const row = M[lang] || M.en;
  return row[key] || M.en[key] || key;
}
